// Closed "occasion" vocabulary powering the mood filter on the places list
// (/places/:city/mood/:vibe) and the chips shown on place cards/detail.
// Server mirror (slug whitelist + payload sanitiser): server/config/vibes.js
// — keep the two slug lists in sync by hand.
//
// Human-facing copy is resolved from translations.js via the key helpers
// below, so it stays translatable (EN/ZH) and out of this config:
//   vibe<Pascal>Label      short chip label
//   vibe<Pascal>SeoTitle   {city}-interpolated <title> for the landing page
//   vibe<Pascal>SeoDesc    {city}-interpolated meta description

export const VIBES = [
  { slug: "date-night", emoji: "🕯️" },
  { slug: "with-the-group", emoji: "👯" },
  { slug: "solo", emoji: "🧍" },
  { slug: "family", emoji: "👨‍👩‍👧" },
  { slug: "special-occasion", emoji: "🎉" },
  { slug: "quick-bite", emoji: "🥪" },
  { slug: "rainy-day", emoji: "☔" },
  { slug: "work-friendly", emoji: "💻" },
  { slug: "dog-friendly", emoji: "🐕" },
];

export const VIBE_SLUGS = VIBES.map((v) => v.slug);

// Most a single place can be tagged with — a vibe stays meaningful only if
// a place isn't wearing half the vocabulary. Enforced in the admin editor.
export const VIBE_MAX_PER_PLACE = 3;

// Fewest places a city+vibe combo needs before its pill / homepage entry /
// sitemap URL goes live — below this the vibe is hidden for that city, not
// greyed (a greyed pill still gets tapped on mobile and disappoints).
export const VIBE_CITY_MIN = 3;

// "date-night" -> "DateNight", for building the translation keys above.
const pascal = (slug) =>
  slug
    .split("-")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");

export const vibeLabelKey = (slug) => `vibe${pascal(slug)}Label`;
export const vibeSeoTitleKey = (slug) => `vibe${pascal(slug)}SeoTitle`;
export const vibeSeoDescKey = (slug) => `vibe${pascal(slug)}SeoDesc`;

export const getVibe = (slug) => VIBES.find((v) => v.slug === slug) || null;
export const isKnownVibe = (slug) => VIBES.some((v) => v.slug === slug);
